module.exports = __webpack_public_path__ + "img/time.5822724f.svg";